/* eslint-disable complexity */
import { isEmpty } from 'lodash';

import { ClosetContextValue, ClosetState, DartInfo } from '../types/closet';
import { GlobalState } from '../types/common';
import {
  ActiveReservation,
  DBCCollectionResponse, IOpenDartModalParams,
  IReservationIdMap,
  IUpdateReservationsProp,
  NBCCollectionResponse, QueryBuilderOptions, Reservations
} from '../types/dart';
import { createFilterLabelForGAEvent, handleUpdateFilters, includeFilters } from './collection';
import { Query } from '../types/collection';
import { collectionGAEvents } from '../hooks/services/curatedCollection';

const moduleName = 'NBC';

// Function Not in use
export const DartModel = (dartDetails, globalContext: GlobalState, closetContext?: ClosetState): DartInfo => {
  const onRackGarmentsFromContext = (closetContext && closetContext.closetGarmentsInfo.onRack) || [];
  const isSubscriber = globalContext.gb.customer.type === 'subscriber';
  const isUserBelowClosetMinimum = isSubscriber ?
  closetContext.closetGarmentsInfo?.closetMinimumToShip - onRackGarmentsFromContext.length > 0 : false;
  const dartUserStatus = dartDetails?.nbcData?.userStatus;
  const etsDetails = dartDetails?.nbcData?.etsDetails;
  const currentDate = new Date();
  const dateUtils = globalContext.gb.dateUtils;
  const utils = globalContext.gb.utils;
  const isFreeDartEnabled = globalContext.liquid.settings.enable_free_dart;
  const isCollectionAvailable = dartUserStatus?.availability?.isCollectionAvailable;
  const isDBCCollectionAvailable = dartUserStatus?.availability?.isDBCCollectionAvailable;
  const isDartEnabled = globalContext.liquid.settings.enable_dart;
  const ets = etsDetails?.shipmentTime && dateUtils.dayComparedToToday(etsDetails.shipmentTime, true);
  const orderByWindowDetails = etsDetails?.orderByWindow &&
dateUtils.differenceBetweenDates(new Date(etsDetails.orderByWindow), currentDate);
  const orderByWindow = orderByWindowDetails?.hours ? (orderByWindowDetails?.hours + ' hour' + (orderByWindowDetails?.hours === 1 ? '' : 's')) : ((orderByWindowDetails?.minutes > 4 ? orderByWindowDetails?.minutes : 'few') + ' minutes');
  const availableSlots = (dartUserStatus?.availability?.slots) || 0;
  const quoteDetails = dartDetails?.quote?.quote?.choices?.length && dartDetails?.quote?.quote?.choices[0];
  const userIncentiveInfo = isFreeDartEnabled ? dartDetails?.quote?.userIncentiveInfo : {};
  const heading = globalContext.i18n.getText('dart_entry_point_heading');
  const shippedText = globalContext.i18n.getText('shipped_text');
  const day = ets?.day;
  let dayText;
  let pickItems;

  if (day === 'today' || day === 'tomorrow') {
    dayText = ets?.day;
  } else {
    dayText = 'on ' + ets?.day;
  }

  const freeDartText = globalContext.i18n.getText('dart_free_text');
  const freeDartOuterHeading = globalContext.i18n.getText('dart_free_dart_outer_heading');

  if (availableSlots > 1) {
    pickItems = globalContext.i18n.getText('pick_items');
  } else if (availableSlots > 0) {
    pickItems = globalContext.i18n.getText('pick_item');
  }

  const nbcConfig = dartDetails?.configuration[moduleName];
  const isUserEligible = isDartEnabled && dartUserStatus?.eligibility?.isUserEligible && dartUserStatus?.availability?.isOptIn;
  const isDartCollectionAvailableForUser = (!isUserBelowClosetMinimum && (nbcConfig && nbcConfig['frontend.collection.unavailability.check'] ? isCollectionAvailable : true)) || isDBCCollectionAvailable;
  const isFreeDartEligible = isUserEligible && isDartCollectionAvailableForUser && (userIncentiveInfo?.isFreeDartEligible || false);
  const isNormalDartEligible = isUserEligible && isDartCollectionAvailableForUser && !isFreeDartEligible;
  const dartDetail: DartInfo = {
    isDartEnabled: isDartEnabled,
    closetLink: globalContext.liquid.closet_link,
    dartLink: globalContext.liquid.settings.dart_link,
    showAvailableSlotsAlpha: globalContext.liquid.settings.showDartAvailableSlotsAlpha,
    localeInfo: window.caastle.localeInfo,
    nbcConfig: nbcConfig,
    showDart: nbcConfig && nbcConfig['feature.enabled.frontend'] === 'true',
    isUserEligible: isUserEligible,
    closetMinCount: dartUserStatus?.eligibility?.closetMinCount,
    isCollectionAvailable: isCollectionAvailable,
    isDBCCollectionAvailable: isDBCCollectionAvailable,
    availableSlots: availableSlots,
    availableSlotsAlpha: utils.numericToAlpha(parseInt(availableSlots, 10)),
    ets: ets,
    FAWRemaining: dartUserStatus?.availability?.optOutTime &&
    dateUtils.differenceBetweenDates(new Date(dartUserStatus.availability.optOutTime), currentDate),
    orderByWindow: orderByWindow,
    orderByWindowHours: orderByWindowDetails?.hours,
    errorCode: dartUserStatus?.eligibility?.error?.code,
    numberOfSlots: dartUserStatus?.eligibility?.numberOfSlots,
    quote: quoteDetails,
    userIncentiveInfo: userIncentiveInfo,
    isFreeDartEligible: isFreeDartEligible,
    freeDartIncentiveDescription: userIncentiveInfo?.incentiveDescription,
    heading: heading,
    shippedText: shippedText,
    freeDartOuterHeading: freeDartOuterHeading,
    dayText: dayText,
    freeDartText: freeDartText,
    pickItems: pickItems,
    isNormalDartEligible: isNormalDartEligible

  };

  return dartDetail;
};

export const eligibilityErrorMap = {
  1: 'optedOut',
  2: 'paymentNotGoodStanding',
  3: 'bcm',
  4: 'at-homeItemsNotRNorTTBed',
  5: 'itemsNotReturned',
  6: 'otherRIDInProgress',
  7: 'otherRIDInProgress',
  8: 'otherRIDInProgress',
  9: 'bulkShipmentCriteriaMismatch',
  10: 'userNotPartOfIncrementalRollout',
  11: 'noShippingTagPresent',
  12: 'userNotEligible',
  13: 'userNotEligible',
  featureNotEnabled: 'userNotEligible',
  default: 'other'
};

export const getErrorType = (dartDetails: DartInfo): string => {
  let errorType;
  let isNBCCollectionAvailable = dartDetails.isCollectionAvailable;
  let isDBCCollectionAvailable = dartDetails.isDBCCollectionAvailable;
  let isUserEligible = dartDetails.isUserEligible;
  let errorCode = dartDetails.errorCode;

  if (errorCode) {
    errorType = eligibilityErrorMap[errorCode];
  } else if (isUserEligible && (!isNBCCollectionAvailable && !isDBCCollectionAvailable)) {
    errorType = 'collectionNotAvailable';
  } else {
    errorType = eligibilityErrorMap.default;
  }

  return errorType;
};

export enum sysDartGAEventCatergory {
    'rn' = 'ReturnNotify - ThankYou',
    'home' = 'closetAtHome',
    'rack' = 'closetOnRack',
    'hold' = 'closetOnHold',
    'ttb' = 'TTB - Thank You',
    'dart' = 'DartLanding'
   }

export const fireSysDartGAEvent = (
  dartSource: string, dartDetails: any, garmentAtHome: number, globalContext: GlobalState
): void => {
  const section = sysDartGAEventCatergory[dartSource];
  let eligibleDartUserType;

  if (dartDetails.isUserEligible) {
    if (dartDetails.isCollectionAvailable) {
      eligibleDartUserType = 'fromCloset';
    } else if (dartDetails.isDBCCollectionAvailable) {
      eligibleDartUserType = 'beyondCloset';
    } else {
      eligibleDartUserType = 'NA';
    }
  } else {
    eligibleDartUserType = 'NA';
  }

  globalContext.gtm.pushVersionedEvent(
    '2.11',
    section,
    'SysDartEligibilityStatus',
    'eligibleStatus = ' +
        (dartDetails.isUserEligible ?
          'eligible' :
          'notEligible') +
        ', notEligibleReason = ' +
        (dartDetails.isUserEligible ?
          'NA' :
          getErrorType(dartDetails)) +
        ', eligibleDartUserType = ' +
        eligibleDartUserType +
        ', freeDartEligibleStatus = ' +
        (dartDetails.isFreeDartEligible ?
          'eligible' :
          'notEligible') +
        ', incentiveName = ' +
        (dartDetails.isFreeDartEligible ?
          dartDetails?.userIncentiveInfo?.incentiveName :
          'NA') +
        ', incentiveCode = ' +
        (dartDetails.isFreeDartEligible ?
          dartDetails?.userIncentiveInfo?.incentiveId :
          'NA') +
        ', userIncentiveCode = ' +
        (dartDetails.isFreeDartEligible ?
          dartDetails?.userIncentiveInfo?.userIncentiveId :
          'NA') +
        ', freeDartPromoMessage = ' +
        (dartDetails.isFreeDartEligible ?
          dartDetails?.userIncentiveInfo
            ?.incentiveDescription :
          'NA') +
        ', priceInDollars = ' +
        (dartDetails?.quote &&
          dartDetails?.quote?.originalPrice) +
        ', remTimeToPlaceOrderHrs = ' +
        dartDetails?.orderByWindowHours +
        ', shippingSLADays = ' +
        (dartDetails?.ets &&
          dartDetails?.ets?.numberOfDaysDiff) +
        ', availableSlots = ' +
        dartDetails?.availableSlots +
        ', garmentsAtHome = ' +
        garmentAtHome,
    null,
    true
  );
};

// Function not in use
export const isLastGarment = (currentSku, atHome): boolean => {
  let atHomeGarments = atHome.filter((garment) => {
    if (garment.sku !== currentSku && !garment.returnNotified) {
      return true;
    }

    return false;
  });

  if (atHomeGarments.length === 0) {
    return true;
  }

  return false;
};

// eslint-disable-next-line max-len
export const updatedReservations = (data, nbcCollection: NBCCollectionResponse, dbcCollection: DBCCollectionResponse) => {
  const updatedData = { ...data };

  updatedData.activeReservations = updatedData.activeReservations.map((activeReservation) => {
    const matchingNBCItem = nbcCollection?.collection?.find((nbcItem) => nbcItem.sku === activeReservation.sku);

    if (matchingNBCItem) {
      activeReservation.imageUrl = matchingNBCItem.productInfo?.images?.[0]?.url;
      activeReservation.size = matchingNBCItem.sku.split('-').slice(-1)[0];
      activeReservation.collectionType = 'nbcCollection';
    } else {
      // eslint-disable-next-line max-len
      const matchingDBCItem = dbcCollection?.reservedProducts?.find((dbcItem) => dbcItem.reservationId === activeReservation.id);

      if (matchingDBCItem) {
        activeReservation.imageUrl = matchingDBCItem.images?.[0]?.url;

        const splittedSKu = activeReservation?.sku?.split('-');

        activeReservation.size = splittedSKu && splittedSKu.length && splittedSKu.pop();
        activeReservation.collectionType = 'dbcCollection';
      }
    }

    return activeReservation;
  });

  return updatedData;
};

// eslint-disable-next-line max-len
export const getUpdatedReservationIdMap = (activeReservations: ActiveReservation[]): IReservationIdMap => activeReservations.reduce((reservationIdMap, item) => {
  reservationIdMap[item.sku] = item.id;

  return reservationIdMap;
}, {});

export const MODAL_NAMES = {
  MISSED_CUTOFF: 'MISSED_CUTOFF',
  RESERVED_STYLES_EXPIRED: 'RESERVED_STYLES_EXPIRED',
  RTP_POOL_SKU_NA: 'RTP_POOL_SKU_NA',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  NOT_ENOUGH_STYLES: 'NOT_ENOUGH_STYLES',
  STYLES_NOT_RESERVED: 'STYLES_NOT_RESERVED',
  SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
  OFFLINE: 'OFFLINE',
  FREE_DART_SUCCESS: 'FREE_DART_SUCCESS',
  DART_SUCCESS: 'DART_SUCCESS',
  MISSED_TODAY_CUTOFF: 'MISSED_TODAY_CUTOFF',
  PAYMENT_SOMETHING_WENT_WRONG: 'PAYMENT_SOMETHING_WENT_WRONG',
  SKIP_POPUP: 'SKIP_POPUP',
  DART_ORDER_EXIT_CONFIRMATION: 'DART_ORDER_EXIT_CONFIRMATION'
};

export const POPUP_CONFIG = {
  [MODAL_NAMES.MISSED_CUTOFF]: {
    popupType: 'missedCutoff',
    headingText: 'dart_missed_cutoff_popup_heading',
    subHeadingText: 'dart_missed_cutoff_popup_subheading',
    ifFirstCta: true,
    ifSecondCta: false,
    showPopupContentText: true,
    virtualPageName: 'Dart_MissedAllCutoff_Popup'
  },
  [MODAL_NAMES.RTP_POOL_SKU_NA]: {
    popupType: 'rtpPoolSKUNotAvailable',
    headingText: 'dart_rtp_pool_sku_na_heading',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: false
  },
  [MODAL_NAMES.RESERVED_STYLES_EXPIRED]: {
    popupType: 'reservedStylesExpired',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: true,
    virtualPageName: 'Dart_ReservedStylesExpired_Popup'
  },
  [MODAL_NAMES.SESSION_EXPIRED]: {
    // should open after current popup closes
    popupType: 'sessionExpired',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: true,
    virtualPageName: 'Dart_SessionExpired_Popup'
  },
  [MODAL_NAMES.NOT_ENOUGH_STYLES]: {
    popupType: 'notEnoughStyles',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: true,
    virtualPageName: 'Dart_UnavailableStyles_Popup'
  },
  [MODAL_NAMES.STYLES_NOT_RESERVED]: {
    popupType: 'stylesNotReserved',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: false
  },
  [MODAL_NAMES.SOMETHING_WENT_WRONG]: {
    popupType: 'somethingWentWrong',
    ifFirstCta: false,
    ifSecondCta: true,
    showPopupContentText: true,
    virtualPageName: 'Dart_SomethingWentWrong_Popup'
  },
  [MODAL_NAMES.OFFLINE]: {
    popupType: 'noInternetConnection',
    ifFirstCta: false,
    ifSecondCta: true,
    showPopupContentText: true
  },
  [MODAL_NAMES.FREE_DART_SUCCESS]: {
    popupType: 'isFreeDart',
    ifFirstCta: true,
    ifSecondCta: false,
    showPopupContentText: true
  },
  [MODAL_NAMES.DART_SUCCESS]: {
    popupType: 'dartSuccess',
    ifFirstCta: true,
    ifSecondCta: false,
    showPopupContentText: true,
    virtualPageName: 'Dart_Success_Popup'
  },
  [MODAL_NAMES.MISSED_TODAY_CUTOFF]: {
    popupType: 'missedTodayCutoff',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: true,
    newEtsDay: 5,
    virtualPageName: 'Dart_MissedTodayCutoff_Popup'
  },
  [MODAL_NAMES.PAYMENT_SOMETHING_WENT_WRONG]: {
    popupType: 'paymentWentWrong',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: true,
    virtualPageName: 'Dart_PaymentError_Popup'
  },
  [MODAL_NAMES.SKIP_POPUP]: {
    popupType: 'skipPopup',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: true
  },
  [MODAL_NAMES.DART_ORDER_EXIT_CONFIRMATION]: {
    popupType: 'exitConfirmation',
    ifFirstCta: true,
    ifSecondCta: true,
    showPopupContentText: false
  }
};

export const PAGINATE_CONFIG = {
  startIndex: '1',
  limit: '24'
};

export const DBC_GARMENT_BATCH_SIZE = 12;

export const openDartModal = ({ dartContext, setDartContext, modalName }: IOpenDartModalParams): void => {
  let dartModalConfig: any = POPUP_CONFIG[modalName];

  if (dartModalConfig) {
    setDartContext({ ...dartContext, dartModalConfig: { ...dartModalConfig, showModal: true } });
  }
};

export const getDartModalConfig = (modalName: string): any => {
  let dartModalConfig: any = POPUP_CONFIG[modalName];

  return dartModalConfig || {};
};

export const calculateCoachingBarMessage = (availableSlots, garmentLeft): string => {
  let msg = '';

  if (garmentLeft === availableSlots) {
    msg = `Select ${availableSlots} available ${garmentLeft > 1 ? 'items' : 'item'}.`;
  } else if (garmentLeft > 1) {
    msg = `Select ${garmentLeft} more items`;
  } else if (garmentLeft === 1) {
    msg = 'Select 1 more item';
  } else {
    msg = 'Review your box';
  }

  return msg;
};

export const isSizePresentOnRTPPool = (rtpAvailableSizes: string[], size: string): boolean => rtpAvailableSizes?.length && (rtpAvailableSizes?.includes(size?.replace('/', '_')) || rtpAvailableSizes?.includes(size));

export const queryBuilderforDBCFilters = (options: QueryBuilderOptions): Query => {
  let query: Query = {
    query: {
      collectionHandle: 'all-products'
    }
  };

  if (!isEmpty(options.appliedFilters)) {
    query = includeFilters(query, options.appliedFilters);
  }

  query.paginate = {
    limit: options.limit,
    startIndex: options.startIndex
  };

  return query;
};

export const handleClearAllClick = (globalContext, dartContext, setDartContext): void => {
  const GAEventLabel = createFilterLabelForGAEvent(dartContext.skuFilterConfig?.appliedFilters,
    dartContext.dbcCollection.detailedFilters);

  collectionGAEvents(globalContext, 'DartCollection', 'clickFilterClearAllButton', GAEventLabel);

  const updatedFilters = handleUpdateFilters(null, [], true, dartContext.skuFilterConfig?.appliedFilters);

  globalContext.gb.utils.removeFromStore('dartFilterConfig');

  setDartContext((prevContext) => ({
    ...prevContext,
    skuFilterConfig: {
      ...prevContext.skuFilterConfig,
      isFilterListUpdating: true,
      appliedFilters: { ...updatedFilters }
    }
  }));
};
